import moment from "moment";
export default function mapUserDetailsToLookup(lookup, userData, categories) {
  if (!lookup || !userData) {
    throw Error("Need look and userData");
  }

  let {
    firmBranches,
    department,
    rightsGroupNames,
    pageDetails,
    titleLevelList,
    industry,
    nicheGroups,
    expertise,
    rolesDetails
  } = lookup;

  let allUsers = userData.map(user => {
    //branch name
    let userBranch = firmBranches.find(loc => user.branch_id === loc.branch_id);
    user.branch_name = userBranch ? userBranch.branch_name : "";

    if (categories && categories.length) {
      let defaultCat = categories.filter(el => el.category_id === user.defaultCategory)
      if (defaultCat.length) {
        user.default_category = defaultCat[0].name;
      } else {
        user.default_category = ``
      }
    }
    //Task Locations
    let taskLocationsList = user.task_Locations.split(",");
    let taskLocations = firmBranches.filter(loc =>
      taskLocationsList.includes(loc.branch_id.toString())
    );
    user.task_location_names = taskLocations
      .map(tl => tl.branch_name)
      .join("|");

    //departments
    let userDepartmentsList = user.department.split(",");
    let userDepartments = department.filter(dep =>
      userDepartmentsList.includes(dep.department_id.toString())
    );
    user.department_names = userDepartments
      .map(d => d.department_name)
      .join("|");

    // Pinned views for MyView
    let pinnedViewsForMyviewList = (user.page_id.length) ? [...new Set(user.page_id.split(","))] : [];
    let pinnedViewsForMyview = pageDetails.filter(pv =>
      pinnedViewsForMyviewList.includes(pv.Bid.toString())
    );
    if (pinnedViewsForMyview.length) {
      pinnedViewsForMyview = pinnedViewsForMyviewList.map(xx => {
        return pinnedViewsForMyview.filter(yy => yy.Bid == xx)[0]
      })
    }
    user.pinned_views_for_myview = pinnedViewsForMyview
      .map(e => (typeof e === "object") ? e.Bucketname : "")
      .join("|");
    // Default MyView View
    let defaultMyView = pageDetails.find(df => user.landingPageId == df.Bid);
    user.default_myview_name = defaultMyView ? defaultMyView.Bucketname : "";

    // userRightGroupNames
    let rightsGroupNamesList = user.belongsto_group.split(",");
    let userRightGroupNames = rightsGroupNames.filter(group => {
      return rightsGroupNamesList.includes(group.Group_id.toString());
    });
    user.belongsto_group_names = userRightGroupNames
      .map(el => el.Group_name)
      .join("|");

    //title level
    let titleLevel = titleLevelList.find(
      title => user.title_level.toString() === title.titleORlevel_id.toString()
    );
    user.title_or_level_names = titleLevel ? titleLevel.titleORlevel_name : "";

    //niche_group

    let nicheGroupList = user.niche_group.split(",");
    let userNicheGroups = nicheGroups.filter(niche => {
      return nicheGroupList.includes(niche.nicheORgroup_id.toString());
    });
    user.niche_or_group_names = userNicheGroups
      .map(el => el.nicheORgroup_name)
      .join("|");

    //Industry Group
    let industryList = user.industry_group.split(",");
    let userIndustries = industry.filter(ind => {
      return industryList.includes(ind.industry_id.toString());
    });
    user.industry_names = userIndustries.map(el => el.industry_name).join("|");

    // expertise
    let expertiseList = user.expertise.split(",");
    let userExpertise = expertise.filter(exp => {
      return expertiseList.includes(exp.expertise_id.toString());
    });
    user.expertise_names = userExpertise.map(el => el.expertise_name).join("|");

    //primary role

    let primaryRole = rolesDetails.find(
      role => user.primary_role.toString() === role.role_id.toString()
    );
    user.primary_role_name = primaryRole ? primaryRole.role_name : "";

    //secondary role

    let secondaryRole = rolesDetails.find(
      role => user.secondary_role.toString() === role.role_id.toString()
    );
    user.secondary_role_name = secondaryRole ? secondaryRole.role_name : "";

    //Wrk_Exp_Begindate
    let workExp = moment(user.wrk_exp_begindate, "YYYY-MM-DDThh:mm:ss");
    let year = moment(user.wrk_exp_begindate, "YYYY-MM-DDThh:mm:ss").year();
    if (year == "1900") {
      workExp = "";
    } else {
      workExp = workExp.format("MM/DD/YY");
    }
    user.wrk_exp_begindate = workExp;

    //last_login
    if(user.last_login){
      let loginTime = moment(user.last_login, "YYYY-MM-DDThh:mm:ss");
      loginTime = loginTime.format("MM/DD/YY hh:mm A");
      user.last_login = loginTime;
    }
    else{
      user.last_login = "";
    }

    //user account status
    user.account_disabled =
      user.account_disabled === "N" ? "Active" : "Inactive";
    // phone number
    let phoneNum = user.phone_number;
    user.phone_number = phoneNum;

    user.selected = false;
    return user;
  });

  return allUsers;
}
